import { Route, Routes } from 'react-router';
import Home from "./components/Home";
import HomeEN from "./components/HomeEN";
import Team from "./components/Team";
import Imprint from "./components/Imprint";
import Privacy from "./components/Privacy";
import Carrer from "./components/Carrer";

import Immobilienverkaufen from "./components/immobilienverkaufen";
import Immobilienschenken from "./components/immobilienschenken";
import Erbenundvererben from "./components/erbenundvererben";
import Vorsorgetreffen from "./components/vorsorgetreffen";
import Familie from "./components/familie";
import Unternehmen from "./components/unternehmen";
import Vereine from "./components/vereine";
import Beglaubigung from "./components/beglaubigung";

import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';

function App() {

  const theme = createTheme({
    typography: {
      fontFamily: [
        'Lato',
        'Arial',
        'Roboto',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    },
  });

    return (
      <ThemeProvider theme={theme}>
      <div className="App">

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/en" element={<HomeEN />} />
          <Route path="/Team" element={<Team />} />
          <Route path="/Karriere" element={<Carrer />} />
          <Route path="/Impressum" element={<Imprint />} />
          <Route path="/Datenschutz" element={<Privacy />} />
          <Route path="/immobilien-kaufen-und-verkaufen" element={<Immobilienverkaufen />} /> 
          <Route path="/immobilienschenken" element={<Immobilienschenken />} /> 
          <Route path="/erbenundvererben" element={<Erbenundvererben />} />           
          <Route path="/vorsorgetreffen" element={<Vorsorgetreffen />} />           
          <Route path="/familie" element={<Familie />} />           
          <Route path="/unternehmen" element={<Unternehmen />} />           
          <Route path="/vereine" element={<Vereine />} />           
          <Route path="/beglaubigung" element={<Beglaubigung />} />           
        </Routes>
  
  
      </div >
      </ThemeProvider>
    );

}

export default App;
